import React from 'react';
import XClose from 'assets/svg/XClose';

interface Props {
    label: string;
    onRemove?: () => void;
}

const FilterV2Chip = ({ label, onRemove }: Props) => (
    <span className="bg-filterV2PrimaryBg text-filterV2Primary rounded h-5 px-2 font-xxs leading-[18px] flex w-fit items-center gap-1">
        <span>{label}</span>
        {onRemove && (
            <span
                className="flex size-2.5 shrink-0 cursor-pointer items-center justify-center"
                onClick={() => onRemove()}
            >
                <XClose />
            </span>
        )}
    </span>
);

export default FilterV2Chip;
